export default __webpack_public_path__ + "static/media/health_and_wellness.ededf0dd.png";